/**
 * @class Expandable
 *
 * @method constructor
 *     @param {HTMLElement} el
 *
 * @method toggleContent
 * @method setHeight
 * @method setToggleText
 * @method init
 *
 * Create an expandable section
 */

const selectors = {
    toggle: '.js-expandable-toggle',
    region: '.js-expandable-region',
    content: '.js-expandable-content',
};

const classes = {
    open: 'is-open',
};

export default class Expandable {
    constructor(el) {
        this.el = el;
        this.toggle = el.querySelector(selectors.toggle);
        this.region = el.querySelector(selectors.region);
        this.content = el.querySelector(selectors.content);

        this.isOpen = this.toggle.ariaExpanded == 'true';
        this.resizeTimeout = null;

        this.init();
    }

    toggleContent(isOpen) {
        this.isOpen = isOpen;

        requestAnimationFrame(() => {
            this.el.classList.toggle(classes.open, isOpen);
            this.toggle.setAttribute('aria-expanded', isOpen);
            this.setToggleText();
        });
    }

    setHeight() {
        this.region.style.setProperty(
            '--height',
            `${this.content.offsetHeight}px`,
        );
        this.region.style.setProperty(
            '--transitionExtra',
            `${this.content.offsetHeight * 0.00005}s`,
        );
    }

    setToggleText() {
        this.toggle.ariaLabel = this.isOpen
            ? this.toggle.dataset.closeText
            : this.toggle.dataset.openText;
    }

    init() {
        setTimeout(() => {
            if (this.el.offsetHeight === 0) return;
            this.setHeight();
        }, 100);
        this.setToggleText();

        this.toggle.setAttribute('aria-expanded', this.isOpen);
        this.el.classList.toggle(classes.open, this.isOpen);

        this.toggle.addEventListener('click', () =>
            this.toggleContent(!this.isOpen),
        );

        const resizeObserver = new ResizeObserver(() => {
            if (!this.isOpen) return;
            this.setHeight();
        });
        resizeObserver.observe(this.content);
    }
}
